import React from 'react'
import PropTypes from 'prop-types'

import './notice.scss'

const Notice = ({ title, text }) => (
	<div className="o-notice">
		{title && <div className="o-notice__title">{title}</div>}
		{text && <div className="o-notice__text">{text}</div>}
	</div>
)

Notice.propTypes = {
	title: PropTypes.string,
	text: PropTypes.node.isRequired,
}

Notice.defaultProps = {
	title: null,
}

export default Notice
